import { __rest } from 'tslib';
import React from 'react';
import { extractMarginProps, extractPaddingProps } from '@10d/tend-ui-styling';
import { Root } from './styled.js';

const Flex = React.forwardRef((props, ref) => {
    const _a = extractMarginProps(props), { rest: withoutMargins } = _a, margins = __rest(_a, ["rest"]);
    const _b = extractPaddingProps(withoutMargins), { rest } = _b, paddings = __rest(_b, ["rest"]);
    return React.createElement(Root, Object.assign({}, rest, { ref: ref }, margins, paddings));
});
Flex.displayName = 'Flex';

export { Flex };
//# sourceMappingURL=Flex.js.map
